import {
  FETCH_ASSURANCES_REQUEST,
  FETCH_ASSURANCES_SUCCESS,
  FETCH_ASSURANCES_FAILURE
} from "./assuranceActions";

const initialState = {
  loading: false,
  assurances: [],
  error: ""
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ASSURANCES_REQUEST:
      return {
        ...state,
        loading: true
      };
    case FETCH_ASSURANCES_SUCCESS:
      return {
        loading: false,
        assurances: action.payload,
        error: ""
      };
    case FETCH_ASSURANCES_FAILURE:
      return {
        loading: false,
        assurances: [],
        error: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
